<template>
  <div class="container_box">
    <!--tab栏区域-->
    <Tabs v-model="pageParams.shelveStatus" :animated="false" class="tabs_styles" @on-click="search()"
      :class="fixedTalg ? 'fixed_box_style' : ''" :style="tabStyles()">
      <TabPane v-for="item in salesStatusList" :label="item.title" :name="item.value.toString()"></TabPane>
    </Tabs>
    <!--头部筛选区域-->
    <div class="filter_box">
      <Form ref="pageParams" :model="pageParams" :label-width="labelWidth" @submit.native.prevent>
        <Row type="flex" :gutter="gutterItem">
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <dropDownFilter
              ref="dropDownFilter"
              inputType="textarea"
              :selectStyle="{width: '110px'}"
              :dropDownInputList="dropDownInputList"
              :defaultSelectValue="defaultSelectValue"
              @changeInput="changeInput"
              @updateInputValue="updateInputValue">
            </dropDownFilter>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1000599')" prop="cnName">
              <Input type="textarea" :placeholder="$t('key1003342')" v-model.trim="pageParams.cnName"></Input>
            </Form-item>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <Form-item :label="`${configCharacters()}` + $t('key1000597')" prop="ymsProductCategoryId">
              <classificationSelect ref="classificationDom" @selectValue="changeValue"></classificationSelect>
            </Form-item>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1003357')" prop="inventory">
              <div class="flex align-items-center">
                <InputNumber :max="9999999" :min="1" v-model="pageParams.minCoreAvailableNumber"
                  :placeholder="$t('key1003310')" :formatter="value => `${parseInt(value)}`" style="min-width: 118px;">
                </InputNumber>
                <span class="mr8 ml8"> - </span>
                <InputNumber :max="9999999" :min="1" v-model="pageParams.maxCoreAvailableNumber"
                  :placeholder="$t('key1003311')" :formatter="value => `${parseInt(value)}`" style="min-width: 118px;">
                </InputNumber>
              </div>
            </Form-item>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <dropDownDateTime
              ref="dropDownDateTime"
              :selectStyle="{width: '100px'}"
              :dropDownTimeList="dropDownTimeList"
              :defaultSelectValue="defaultSelectTimeValue"
              @changeInput="changeTimeInput"
              @selectTime="selectTime"
              @resetTime="resetTime">
            </dropDownDateTime>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1003345')" prop="productTagIds">
              <Select v-model="pageParams.productTagIds" filterable transfer multiple :placeholder="$t('key1003346')">
                <Option v-for="item in productTagNamesList" :value="item.ymsProductTagId">{{ item['productLabel_' + languagesVal] }}</Option>
              </Select>
            </Form-item>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol" v-if="showProductSaleCountrySet && moreFilter">
            <FormItem :label="$t('key1000374')" prop="countryCodes">
              <Select v-model="pageParams.countryCodes" filterable multiple>
                <Option v-for="item in countrysList" :value="item.twoCode" :key="item.twoCode">{{ item.name }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1002433')" prop="ymsDeliveryPlaceIds">
              <Select v-model="pageParams.ymsDeliveryPlaceIds" filterable transfer multiple>
                <Option v-for="(item, index) in placeOfShipmentList" :value="item.ymsDeliveryPlaceId" :key="index">{{ item.deliveryPlaceName }}</Option>
              </Select>
            </Form-item>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol" v-show="moreFilter">
            <Form-item :label="$t('key1003348')" prop="deliveryCountryCodes">
              <Select v-model="pageParams.deliveryCountryCodes" filterable transfer multiple>
                <Option v-for="item in shippingWarehouseCountryList" :value="item.twoCode" :key="item.twoCode">{{ item.name }}</Option>
              </Select>
            </Form-item>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol" v-show="moreFilter">
            <Form-item :label="$t('key1001227')" prop="deliveryWarehouses">
              <Select v-model="pageParams.deliveryWarehouses" filterable transfer multiple>
                <Option v-for="(item, index) in deliveryWarehousesList" :value="item.ymsWarehouseId" :key="index">{{ item.name }}</Option>
              </Select>
            </Form-item>
          </Col>
          <Col style="min-width: 200px;" push="1">
            <Button @click="reset" icon="md-refresh" class="mr10">{{ $t('key1000109') }}</Button>
            <Button type="primary" @click="search" icon="md-search">{{ $t('key1000361') }}</Button>
          </Col>
        </Row>
        <Row type="flex" justify="end" :gutter="gutterItem">
          <Col style="text-align: right;">
            <Button size="small" @click="toggleMoreFilter">{{ moreFilterMes }}
              <Icon :type="moreFilterIcon" size="small"></Icon>
            </Button>
          </Col>
        </Row>
      </Form>
    </div>
    <!--功能按钮操作区域-->
    <div class="operation_box">
      <Button type="primary" class="mr15" @click="addProductBtn" v-if="getPermission('ymsProductInfoCore_insertCoreProduct')">
        {{ $t('key1001092') }}
      </Button>
      <Button type="primary" class="mr15" v-if="getPermission('ymsProductInfoCore_excelImport')"
        @click="$refs['commodityInfo'].initImportCommodityInfoData()">
        {{ $t('key1000257') }}
      </Button>
      <Dropdown transfer @on-click="changeExportBtn" v-if="getPermission('ymsProductInfoCore_batchExport')">
        <Button type="primary">
          <span>{{ $t('key1003082') }}</span>
          <Icon type="ios-arrow-down"></Icon>
        </Button>
        <DropdownMenu slot="list">
          <DropdownItem name="1">{{ $t('key1003083') }}</DropdownItem>
          <DropdownItem name="2">{{ $t('key1003084') }}</DropdownItem>
        </DropdownMenu>
      </Dropdown>
      <Dropdown class="ml15" transfer @on-click="batchSuspensionOfSalesBtn"
        v-if="getPermission('ymsProductInfoCore_stopMoreProductInfo') && pageParams.shelveStatus === '1'">
        <Button type="primary">
          <span>{{ $t('key1003360') }}</span>
          <Icon type="ios-arrow-down"></Icon>
        </Button>
        <DropdownMenu slot="list">
          <DropdownItem name="1">{{ $t('key1003361') }}</DropdownItem>
          <DropdownItem name="2" :disabled="true">{{ $t('key1003362') }}</DropdownItem>
        </DropdownMenu>
      </Dropdown>
      <Button class="ml15" v-if="getPermission('ymsProductInfoCore_batchSetProductTagRelated')" @click="batchConfigLabelBtn">
        {{ $t('key1001441') }}
      </Button>
    </div>
    <!--列表区域-->
    <div class="table_box">
      <Row class="table_header_box" :class="fixedTableTitleTalg ? 'fixed_table_header_box_style' : ''" :style="tableTitleStyles()">
        <Col class="title" v-for="(item,index) in tableColumns" :key="item.key" :span="item.span" :class="index === 0 ? 'pl20' : ''">
          {{ item.name }}
        </Col>
        <Checkbox :disabled="tableData.length <=0" class="select_table_box" v-model="selectAllTable" @on-change="allTableChange"></Checkbox>
      </Row>
      <!--暂无数据-->
      <div class="no_classify" v-if="tableData.length <=0">
        <img :src="noContent" width="250" height="250" :alt="$t('key1000104')">
      </div>
      <template v-else>
        <div class="table_box_item" v-for="(item,index) in tableData" :key="index">
          <div class="flex align-items-center mb8">
            <Checkbox class="mr8" v-model="item.tableChecked" @on-change="(value) => tableChange(value, item)"></Checkbox>
            <p class="ellipsis_1" :class="item.isDelete !== 1 ? 'themeColor text-decoration cursor' : ''"
              @click="toGoodsDetails(item)" :title="item.name">
              {{ item.name }}
            </p>
            <Tag v-if="item.isDelete === 1" class="ml8" color="error">{{ $t('key1000591') }}</Tag>
          </div>
          <Row>
            <!--商品信息-->
            <Col class="commodityInfo_box" :span="tableSapns['commodityInfo']">
              <div class="flex pl25" v-viewer="viewerConfig">
                <div class="img_box">
                  <img
                    :src="setImgPath(item.imagePath, null, '70x70', null, true)"
                    :data-original="setImgPath(item.imagePath, null, null, null, false)"
                    @error="setErrorImg($event)" alt="">
                </div>
                <div class="ml10">
                  <p class="flex mb5">
                    <span>{{ $t('key1000600') + item.supplierSpu }}</span>
                    <Icon type="ios-copy-outline" size="18" color="#01a6ee" class="ml4 cursor mr10"
                      :title="$t('key1000003')" @click="commonCopyContentFun(item.supplierSpu)"/>
                  </p>
                  <p class="flex mb5">
                    <span>{{ configCharacters(false) + 'SPU：' + item.ymsSpu }}</span>
                    <Icon type="ios-copy-outline" size="18" color="#01a6ee" class="ml4 cursor mr10"
                      :title="$t('key1000003')" @click="commonCopyContentFun(item.ymsSpu)"/>
                  </p>
                  <p class="themeColor text-decoration cursor display-inline-block" @click="toSkuDetails(item)">
                    {{ $t('key1003351') + item.skuNumber + '）' }}
                  </p>
                </div>
              </div>
            </Col>
            <!--商品分类-->
            <Col :span="tableSapns['classificationName']" class="pr25">{{ item.classificationName }}</Col>
            <!--商品可售卖国/地区-->
            <template v-if="showProductSaleCountrySet">
              <Col :span="tableSapns['countryCodes']" class="pr20">{{ item.sellableCountryNames }}</Col>
            </template>
            <!--时间-->
            <Col :span="tableSapns['time']">
              <p class="mb4" v-for="ele in item.timerList" :key="ele.key" v-if="ele.show || item.viewMoreTalg">
                {{ ele.name + '：' + ele.time }}
              </p>
              <p v-if="item.hasMoreTime" class="themeColor cursor text-decoration display-inline-block" @click="item.viewMoreTalg = !item.viewMoreTalg">
                {{ item.viewMoreTalg ? $t('key1000141') : $t('key1000022') }}
              </p>
            </Col>
            <!--商品标签-->
            <Col :span="tableSapns['productLabel']" class="pr20">{{ item.productLabelName }}</Col>
            <!--操作-->
            <Col :span="tableSapns['operation']">
              <operationButtons :operationList="getOperationList(item)"></operationButtons>
            </Col>
          </Row>
          <!--仓储与价格-->
          <Row class="storageAndPricing_box" v-if="item.storageAndPricingList.length > 0">
            <Col :span="21">
              <Divider class="mt15 mb10"/>
              <div class="flex align-items-start wid100P">
                <h2 class="font-size-15 font-weight-bold color-333">{{ $t('key1003363') }}</h2>
                <div class="flex_1">
                  <Row class="storageAndPricing_item" v-for="ele in item.visibleStorageList" :key="ele.ymsWarehouseId">
                    <Col :span="6">
                      <p>{{ $t('key1001227') + ele.productShippingWarehouseName }}</p>
                    </Col>
                    <Col :span="6">
                      <div class="flex align-items-center">
                        <span>{{ $t('key1002433') }}</span>
                        <p>{{ ele.deliveryPlaceName }}</p>
                        <Tag color="primary" class="ml5">{{ ele.countryName }}</Tag>
                      </div>
                    </Col>
                    <Col :span="6">
                      <p class="mb4" v-for="(k, idx) in ele.priceDisplayList" :key="idx">{{ k.name + k.value }}</p>
                    </Col>
                    <Col :span="6">
                      <p class="mb4">{{ $t('key1003367') + (ele.centralWarehouseInventoryNumber || 0) }}</p>
                    </Col>
                  </Row>
                  <p v-if="item.storageAndPricingList.length > 2" class="themeColor text-decoration cursor pl25 display-inline-block"
                    @click="toggleStorageAndPricing(item)">
                    {{ item.showAllStorage ? $t('key1000141') : $t('key1003359') + item.storageAndPricingList.length + '）' }}
                  </p>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </template>
      <div class="flex align-items-center" :class="selectTableData.length>0 ? 'justify-content-between' : 'justify-content-end'">
        <div v-if="selectTableData.length>0" class="flex align-items-center font-size-14">
          <span>{{ $t('key1000365') }}</span>
          <span class="themeColor font-weight-bold">{{ selectTableData.length }}</span>
          <span>{{ $t('key1001120') }}</span>
          <span class="themeColor cursor ml12" @click="cancelSelectData">{{ $t('key1003364') }}</span>
        </div>
        <Page
          :transfer="true"
          v-if="!tableLoading"
          :total="total"
          @on-change="changePage"
          show-total
          :page-size="pageParams.pageSize"
          show-elevator
          :current="pageParams.pageNum"
          show-sizer
          @on-page-size-change="changePageSize"
          placement="top"
          :page-size-opts="pageArray">
        </Page>
      </div>
    </div>
    <!--日志弹窗-->
    <commonLogModal
      ref="commonLog"
      logMode="SELF_OPERATED_PRODUCT"
      operationType="spu"
      :showPage="true">
    </commonLogModal>
    <!--打印云卖面单-->
    <printYunSkuModal :selfOperatedProducts="true" ref="printYunSku" :printUrl="printUrl"></printYunSkuModal>
    <!--导出数据字段弹窗-->
    <exportFieldsModal
      ref="exportFields"
      :dimensionTalg="true"
      :exportFieldsTitle="$t('key1003366')"
      paramKeyColums="ymsProductInfoExportColumns"
      :customFieldExportList="customFieldExportList"
      :dimensionTypeList="dimensionTypeList"
      @exportFieldsDataBtn="exportFieldsDataBtn">
    </exportFieldsModal>
    <!--库存详情弹窗-->
    <inventoryDetailsModal ref="inventoryDetails" @updateData="updateDataFun"></inventoryDetailsModal>
    <!--批量配置标签弹窗-->
    <batchConfigLabelModal
      configurationType="commodity"
      :selfOperatedProducts="true"
      ref="batchConfigLabel"
      @updateData="updateDataFun">
    </batchConfigLabelModal>
    <!--商品售卖国弹窗-->
    <sellingCountrySettingModal
      ref="sellingCountrySetting"
      :sellingCountrySettingData="shippingCountryData"
      @updateData="updateDataFun">
    </sellingCountrySettingModal>
    <!--导入商品弹窗-->
    <importCommodityInfoModal
      :isSelfOperated="1"
      ref="commodityInfo"
      :importInterface="importInterface"
      @updateData="updateDataFun">
    </importCommodityInfoModal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import dropDownFilter from "@/components/common/dropDownFilter";
import printYunSkuModal from '@/views/yms/components/commodityManage/printYunSkuModal.vue';
import {PRODUCTTYPES} from "@/utils/enum";
import exportFieldsModal from "@/components/common/exportFieldsModal";
import {
  amountHandel, commonCopyContent, getAllProductLabelData, getBatchCategoryInfoData,
  getNationalContinentName, handleCountryContinentData, pageJump, setConfigCharacters,
  to1688ByImg, commonLocalStorage, getAllCountrysData, getCloudTreeData, getDataSetBatchList,
  getEnumList, getPlaceOfShipmentCountryData
} from "@/utils/common";
import inventoryDetailsModal from "@/components/common/inventoryDetailsModal.vue";
import dropDownDateTime from "@/components/common/dropDownDateTime.vue";
import classificationSelect from "@/components/common/classificationSelect.vue";
import batchConfigLabelModal from "@/components/common/batchConfigLabelModal.vue";
import sellingCountrySettingModal from "@/components/common/sellingCountrySettingModal.vue";
import {showLoadingModal, hideLoadingModal} from "@/utils/loading";
import operationButtons from "@/components/common/operationButtons.vue";
import importCommodityInfoModal from "@/components/common/importCommodityInfoModal.vue";
import commonLogModal from "@/components/common/commonLogModal.vue";

export default {
  name: 'selfOperatedProductsList',
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      pageParamsStatus: false,
      pageParams: {
        ymsProductCategoryId: null,
        cnName: '',
        shelveStatus: '1',
        ymsSpus: '',
        ymsSkus: '',
        supplierSkus: '',
        supplierSpus: '',
        ymsDeliveryPlaceIds: [], // 发货地
        deliveryCountryCodes: [], // 发货仓国家
        deliveryWarehouses: [], // 发货仓
        maxCoreAvailableNumber: null, // 中心仓库存最大值
        minCoreAvailableNumber: null, // 中心仓库存最小值

        createdStartTime: null, // 创建开始时间
        createdEndTime: null, // 创建结束时间
        updatedStartTime: null, //  更新开始时间
        updatedEndTime: null, // 更新结束时间
        orderBy: 'createdTime', // 默认按照创建时间降序排序
        upDown: 'down',
        productTagIds: [],
        countryCodes: [],
        isSelfOperated: 1,
        pageNum: 1,
        pageSize: 15
      },
      total: 0,
      ymsProductId: null,
      originalColumns: [
        {span: 6, key: 'commodityInfo', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000383')},
        {span: 3, key: 'classificationName', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003303')},
        {span: 3, key: 'countryCodes', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000371')},
        {span: 4, key: 'time', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002451')},
        {span: 3, key: 'productLabel', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003304')},
        {span: 2, key: 'operation', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319')},
      ],
      tableData: [],
      defaultSelectValue: 1,
      dropDownInputList: [
        {title: `${setConfigCharacters(false)}SPU`, value: 1, placeholder: `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000324')}${setConfigCharacters(false)}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001089')}`, parameterKey: 'ymsSpus'},
        {title: `${setConfigCharacters(false)}SKU`, value: 2, placeholder: `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000324')}${setConfigCharacters(false)}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001090')}`, parameterKey: 'ymsSkus'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001093'), value: 3, placeholder: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001094'), parameterKey: 'supplierSpus'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000586'), value: 4, placeholder: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003305'), parameterKey: 'supplierSkus'}
      ],
      ymsProductCategoryList: [],
      selectTableData: [],
      exportType: '1',
      ymsProductIdList: [],
      dimensionTypeList: [
        {value: 1, show: true, label: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003306'), desc: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003307')},
        {value: 2, show: true, label: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003308'), desc: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003309')}
      ],
      defaultSelectTimeValue: 1,
      productTypeList: PRODUCTTYPES,
      productTagNamesList: [],
      shippingCountryData: [],
      placeOfShipmentList: [], //发货地
      shippingWarehouseCountryList: [], // 发货仓国家
      deliveryWarehousesList: [], // 发货仓
      countrysList: [],
      fixedTalg: false,
      fixedTableTitleTalg: false,
      selectAllTable: false,
      enumData: [],
      importInterface: api.post_ymsProductInfoCore_excelImport,
      customFieldExportList: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000383'),
          titleKey: 'supplierInfoColums',
          selectList: ['cnName'], // 选中导出字段的key
          checkBoxList: [
            {type: [1, 2], paramKey: 'cnName', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001099'), disabled: true},
            {type: [1, 2], paramKey: 'productCategoryNavigation', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001604')},
            {type: [1, 2], paramKey: 'ymsSpu', paramValue: `${setConfigCharacters(false)}SPU`},
            {type: [1, 2], paramKey: 'supplierSpu', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001093')},
            {type: [1, 2], paramKey: 'shelveStatus', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003317')},
            {type: [1, 2], paramKey: 'shelvedTime', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003318')},
            {type: [1, 2], paramKey: 'underCarriageTime', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003319')},
            {type: [1, 2], paramKey: 'createdTime', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002159')},
            {type: [1, 2], paramKey: 'updatedTime', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002477')},
            {type: [1, 2], paramKey: 'ymsSku', paramValue: `${setConfigCharacters(false)}SKU`},
            {type: [2], paramKey: 'goodsSpecification', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000587')},
            {type: [1, 2], paramKey: 'supplierSku', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000586')},
            {type: [1, 2], paramKey: 'allottedQuantity', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000242')},
            {type: [1, 2], paramKey: 'availableQuantity', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000243')},
            {type: [1, 2], paramKey: 'productTypeStr', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003328')},
            {type: [1, 2], paramKey: 'productTagName', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003304')},
            {type: [1, 2], paramKey: 'productSaleCountryName', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000371')},
            {type: [1, 2], paramKey: 'deliveryPlaceName', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002585')},
            {type: [1, 2], paramKey: 'ymsWarehouseName', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001342'), disabled: true},
            {type: [1, 2], paramKey: 'originalCountryCode', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001607')},
          ]
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003302'),
          titleKey: 'productInfoColums',
          selectList: [], // 选中导出字段的key
          checkBoxList: [
            {type: [1, 2], paramKey: 'supplierPrice', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000882')},
            {type: [1, 2], paramKey: 'suggestPrice', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003365')},
            {type: [1, 2], paramKey: 'selfDeliveryInventory', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000890')},
          ]
        }
      ],
      dropDownTimeList: [
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002159'), value: 1, parameterKey: ['createdStartTime', 'createdEndTime']},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002477'), value: 2, parameterKey: ['updatedStartTime', 'updatedEndTime']}
      ],
      printUrl: api.post_productGoods_appendYmsCoreExpressBill
    };
  },
  mounted() {
    window.addEventListener('scroll', this.scrollFixedTopFun);
  },
  computed: {
    // 批发模式
    showProductWholesaleModel() {
      const obj = commonLocalStorage.getItem('saasConfigurationItems') ?? this.$store.state.saasConfigurationItems;
      return Number(obj?.productWholesaleModelSaas) === 1;
    },
    showSidebarMenu() {
      return this.$store.state.showSidebarMenu;
    },
    filterKeyList() {
      return this.dropDownInputList.map((item) => {
        return item.parameterKey
      });
    },
    // 获取当前登录用户的信息
    userInfo() {
      if (this.$store.state.erpConfig) {
        return this.$store.state.erpConfig.userInfo;
      } else {
        return '';
      }
    },
    // 是否展示售卖国
    showProductSaleCountrySet() {
      const obj = commonLocalStorage.getItem('configurationItemInfo') ?? this.$store.state.configurationItemInfo;
      return Number(obj?.enableProductSaleCountrySet) === 1;
    },
    // 处理列表字段
    tableColumns() {
      const TOTAL_SPAN = 24;
      // 需要隐藏的列
      const hideKeys = [];
      if (!this.showProductSaleCountrySet) {
        hideKeys.push('countryCodes');
      }
      const columns = this.originalColumns.filter(col => !hideKeys.includes(col.key)).map(col => ({...col}));
      const usedSpan = columns.reduce((sum, col) => sum + col.span, 0);
      const diff = TOTAL_SPAN - usedSpan;
      // 平均分配剩余 span
      if (diff > 0 && columns.length > 0) {
        const avg = Math.floor(diff / columns.length);
        let remainder = diff % columns.length;
        columns.forEach(col => {
          col.span += avg;
          if (remainder > 0) {
            col.span += 1;
            remainder--;
          }
        });
      }
      return columns;
    },
    tableSapns() {
      let obj = {};
      this.tableColumns.forEach(item => {
        obj[item.key] = item.span;
      });
      return obj;
    },
    // 预览图配置
    viewerConfig() {
      return {
        url: 'data-original',
        ...this.viewerOptions
      }
    },
    // 销售状态
    salesStatusList() {
      const ENUM_KEY = 'YmsProductInfoShelveStatusCoreEnum';
      let list = getEnumList(this.enumData, ENUM_KEY);
      list = list.filter((item) => item.value !== '0')
      // 自定义顺序
      const order = ['1', '2']
      list.sort((a, b) => {
        return order.indexOf(a.value) - order.indexOf(b.value)
      });
      return list;
    }
  },
  created() {
    this.initFun();
  },
  methods: {
    //复制方法 注：方法传参中不能有中文字，会导致翻译塞值报错
    commonCopyContentFun(value) {
      commonCopyContent(value, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000002'))
    },
    // 初始化接口数据
    async initFun() {
      let v = this;
      showLoadingModal(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000514'), 'init_productList');
      v.warehouseList = [];
      v.productTagNamesList = [];
      try {
        let enumKeyList = ['YmsProductInfoShelveStatusCoreEnum'];
        v.enumData = await getDataSetBatchList(enumKeyList);
        // 1) 国家
        const countrysList = await getAllCountrysData('cn', true);
        v.shippingCountryData = handleCountryContinentData(countrysList);
        v.countrysList = countrysList;

        // 2) 发货地 + 发货仓国家
        const obj = await getPlaceOfShipmentCountryData('platformWarehouse');
        // 发货地
        v.placeOfShipmentList = obj.ymsDeliveryPlaces || [];
        // 发货仓国家
        let countryCodes = obj.countryCodes || [];
        this.shippingWarehouseCountryList = countrysList.filter((item) => {
          return countryCodes.includes(item.twoCode);
        });

        // 3) 发货仓
        await v.getDeliveryWarehousesData();

        // 4) 商品标签
        v.productTagNamesList = await getAllProductLabelData();

        // 5) 获取分类数据
        await getCloudTreeData(api.post_ymsProductCategory_queryAll, 'tile').then((data) => {
          let ymsProductCategoryId = null;
          let seleteYmsProductCategoryId = localStorage.getItem('seleteYmsProductCategoryId');
          if (seleteYmsProductCategoryId) {
            ymsProductCategoryId = JSON.parse(seleteYmsProductCategoryId);
          }
          v.$nextTick(() => {
            v.$refs['classificationDom'].initClassificationData(data, ymsProductCategoryId);
          });
        });
        // 6) 查询列表数据
        v.search();
      } catch (e) {
        console.error('initFun error:', e);
        hideLoadingModal('init_productList', 200);
      }
    },
    // 分类筛选
    changeValue(value) {
      this.pageParams.ymsProductCategoryId = value;
      localStorage.removeItem('seleteYmsProductCategoryId');
    },

    // 查询按钮
    search() {
      this.pageParams.pageNum = 1;
      this.getList();
    },
    // 重置按钮
    reset() {
      let v = this;
      v.$refs['pageParams'].resetFields();
      v.changeTimeInput(1);
      v.changeInput(1);
      v.pageParams.ymsProductCategoryId = null;
      v.pageParams.minCoreAvailableNumber = null;
      v.pageParams.maxCoreAvailableNumber = null;
      v.$refs['classificationDom'].reset();
      localStorage.removeItem('seleteYmsProductCategoryId');
      v.search();
    },
    // 处理接口参数
    handleParameter() {
      let v = this;
      let params = Object.assign({}, v.pageParams);
      let seleteYmsProductCategoryId = localStorage.getItem('seleteYmsProductCategoryId');
      if (seleteYmsProductCategoryId) {
        params.ymsProductCategoryId = JSON.parse(seleteYmsProductCategoryId);
        v.pageParams.ymsProductCategoryId = JSON.parse(seleteYmsProductCategoryId);
      }
      for (let key in params) {
        if (v.filterKeyList.includes(key)) {
          params[key] = v.sepCommasFn(params[key], ['\n']);
        }
      }
      params.shelveStatus = Number(v.pageParams.shelveStatus);
      return params;
    },
    // 列表查询的方法
    async getList() {
      if (!this.getPermission('ymsProductInfoCore_query')) {
        return this.gotoError();
      }
      this.selectAllTable = false;
      this.tableData = [];
      this.total = 0;
      if (!this.verifyInventory()) return;
      this.tableLoading = true;
      showLoadingModal(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003332'), 'productList');
      try {
        localStorage.removeItem('originalPath');
        const keyList = ['name', 'supplierMerchantIdName'];
        const response = await this.axios.post(api.post_ymsProductInfoCore_query, this.handleParameter());
        if (response.data.code !== 0) return;
        const data = response.data.datas;
        if (!data) return;
        const list = data.list || [];
        this.total = data.total;
        if (list.length === 0) {
          this.handleTableData([]);
          return;
        }
        const ymsProductCategoryIds = [];
        list.forEach(item => {
          item.supplierMerchantIdName = item.supplierMerchantIdName?.split('/')[1] || '';
          ymsProductCategoryIds.push(item.ymsProductCategoryId);
        });
        let finalList = list;
        if (ymsProductCategoryIds.length) {
          const newData = await getBatchCategoryInfoData(api.post_ymsProductCategory_queryByYmsProductCategoryIds, list, ymsProductCategoryIds);
          finalList = this.handleMultilinguaTableFields(newData, keyList);
        } else {
          finalList = this.handleMultilinguaTableFields(list, keyList);
        }
        this.handleTableData(finalList);
      } catch (err) {
        console.error('getList error:', err);
      } finally {
        this.tableLoading = false;
        this.$nextTick(() => {
          hideLoadingModal('productList', 200);
          hideLoadingModal('init_productList', 200);
        });
      }
    },
    // 处理列表数据
    handleTableData(data) {
      const priceTitle = this.showProductWholesaleModel ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000916') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000917');
      /**
       * @Description: 金额区间格式化
       * @param {Array<Number>} list 金额数组
       * @return {String}
       */
      const getMinMaxAmount = (list = []) => {
        if (!list.length) return '-';
        const min = Math.min(...list);
        const max = Math.max(...list);
        return min === max ? amountHandel(min) : `${amountHandel(min)} ~ ${amountHandel(max)}`;
      };

      /**
       * @Description: 过滤有效数字
       * @param {Array} list
       * @return {Array<Number>}
       */
      const toValidNumberList = (list = []) => {
        return list.map(v => Number(v)).filter(v => Number.isFinite(v));
      };

      // 处理仓库、价格数据
      const normalizeWarehouse = (w, item) => {
        const inventories = (item.ymsReportInventories || []).filter(i => i.warehouseId === w.warehouseId);
        // ================== 价格 ==================
        let directShippingList = [];
        if (inventories.length) {
          const currency = inventories[0].currency || item.currency;
          const productCostList = toValidNumberList(inventories.map(i => i.productCost));
          const suggestPriceList = toValidNumberList(inventories.map(i => i.suggestPrice));
          const wholesalePriceList = toValidNumberList(inventories.map(i => i.wholesalePrice));
          directShippingList = [
            {
              name: `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000583')}${currency}）：`,
              value: getMinMaxAmount(productCostList)
            },
            {
              name: `${priceTitle}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000808')}${currency}）：`,
              value: getMinMaxAmount(suggestPriceList)
            }
          ];
          if (this.showProductWholesaleModel) {
            directShippingList.push({
              name: `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000810')}${currency}）：`,
              value: getMinMaxAmount(wholesalePriceList)
            });
          }
        }

        // ================== 发货仓 / 发货地 / 国家 ==================
        const warehouseInfo = (this.deliveryWarehousesList || []).find(i => i.ymsWarehouseId === w.warehouseId) || {};
        const deliveryPlaceInfo = (this.placeOfShipmentList || []).find(j => j.ymsDeliveryPlaceId === warehouseInfo.ymsDeliveryPlaceId) || {};
        const countryInfo = (this.shippingWarehouseCountryList || []).find(k => k.twoCode === warehouseInfo.countryCode) || {};
        const availableNumber = (item.coreDeliveryWarehouse || []).find(i => i.ymsWarehouseId === w.warehouseId)?.availableNumber || 0;
        return {
          ...w,
          countryName: countryInfo?.name || '',
          deliveryPlaceName: deliveryPlaceInfo?.deliveryPlaceName || '',
          productShippingWarehouseName: warehouseInfo?.name || '',
          centralWarehouseInventoryNumber: availableNumber,
          priceDisplayList: directShippingList
        };
      };

      // 处理商品标签
      const processingProductLabel = (item) => {
        let list = [];
        let productTagNames = item.productTagNames || [];
        if (productTagNames.length > 0) {
          list = productTagNames.map(tag => {
            let parsedTag = JSON.parse(tag);
            return parsedTag[this.languagesVal];
          }).filter(name => name);
        }
        return list.join('、');
      }
      // 处理商品可售卖国
      const processingSellingCountry = (item) => {
        let countryCodes = item.countryCodes || [];
        let list = getNationalContinentName(countryCodes, this.shippingCountryData, 'name');
        return list.join('、');
      }
      // 处理时间
      const processingTime = (item) => {
        const baseList = [
          {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002159'), key: 'createdTime', show: true},
          {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002477'), key: 'updatedTime', show: true},
          {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003319'), key: 'underCarriageTime', show: false}
        ];
        const list = baseList.map(ele => ({
          ...ele,
          time: item[ele.key] ? this.$uDate.dealTime(item[ele.key], 'fulltime') : '-'
        }));
        // 是否存在可展开项
        item.hasMoreTime = list.some(i => !i.show);
        // 默认收起
        item.viewMoreTalg = false;
        return list;
      };

      data.forEach(item => {
        item.tableChecked = false;
        const newList = (item.ymsProductDeliverWarehouses || []).map(w => normalizeWarehouse(w, item));
        item.storageAndPricingList = [...newList];
        item.productLabelName = processingProductLabel(item);
        item.sellableCountryNames = processingSellingCountry(item);
        item.timerList = processingTime(item);
        /** ===== 仓储与价格：展开/收起控制 ===== */
        item.showAllStorage = false;
        item.visibleStorageList = item.storageAndPricingList.slice(0, 2);
      });
      this.tableData = data;
      this.recordSelectGoods(data);
      this.updateTableDom('selection', 2000);
    },
    // 批量停售
    batchSuspensionOfSalesBtn(value) {
      let ymsProductIds = [];
      if (value === '1') {
        if (this.selectTableData.length <= 0) {
          this.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003333'));
          return false;
        }
        ymsProductIds = this.selectTableData.map((item) => {
          return item.ymsProductId
        });
      } else {
        if (this.tableData.length <= 0) {
          this.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003334'));
          return false;
        }
        ymsProductIds = this.tableData.map((item) => {
          return item.ymsProductId
        });
      }
      this.axios.post(api.post_ymsProductInfoCore_stopMoreProductInfo, ymsProductIds, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(res => {
        if (res.data.code === 0) {
          this.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000489'));
          this.ymsProductIdList = [];
          this.selectTableData = [];
          this.pageParamsStatus = true;
        }
      });
    },
    // 选择导出数据类型  1 按选中导出 2 按查询结果导出
    changeExportBtn(value) {
      this.exportType = value;
      if (value === '1') {
        if (this.selectTableData.length <= 0) {
          this.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003077'));
          return false;
        }
      } else {
        if (this.tableData.length <= 0) {
          this.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003078'));
          return false;
        }
      }
      this.$refs['exportFields'].getExportFieldsSetting();
    },
    // 导出数据
    exportFieldsDataBtn(obj) {
      let v = this;
      let query = v.handleParameter();
      if (v.exportType === '1') {
        query.ymsProductIds = v.selectTableData.map((item) => {
          return item.ymsProductId
        });
      } else {
        query.ymsProductIds = [];
      }
      v.$refs['exportFields'].saveExportFieldsSetting().then((value) => {
        if (value) {
          query.exportType = obj.dimensionType;
          v.axios.post(api.post_ymsProductInfoCore_batchExport, query,
            {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(res => {
            if (res.data.code === 0) {
              v.$refs['exportFields'].exportFieldsModal = false;
              let taskNumber = res.data.datas;
              setTimeout(() => {
                pageJump('/yms.html#/exportTask?operateCode=' + taskNumber, '/yms-core-service', '_blank');
              }, 30)
            }
          });
        }
      });
    },
    // 获取下拉选项筛选条件的值
    updateInputValue(data) {
      this.pageParams[data.key] = data.value;
    },
    // 改变默认下拉选项的值
    changeInput(value) {
      this.defaultSelectValue = value;
      this.$refs.dropDownFilter.inputValue = '';
      this.dropDownInputList.map((item) => {
        if (Object.keys(this.pageParams).includes(item.parameterKey)) {
          this.pageParams[item.parameterKey] = '';
        }
      });
    },
    // 停售SPU商品
    shelfBtn(ymsProductId) {
      let v = this;
      v.axios.put(api.put_ymsProductInfoCore + `${ymsProductId}`).then(response => {
        if (response.data.code === 0) {
          this.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000097'));
          v.getList();
        }
      });
    },
    // 上架SPU商品
    groundingBtn(ymsProductId) {
      let v = this;
      v.axios.put(api.put_ymsProductInfoCore_dercarriage + `${ymsProductId}`).then(response => {
        if (response.data.code === 0) {
          this.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000097'));
          v.getList();
        }
      });
    },
    // 前页全选/取消全选列表数据
    allTableChange(value) {
      this.tableData.map((item) => {
        item.tableChecked = value;
      });
      // 取消全选：从跨页已选数据中移除当前页数据
      if (!value) {
        const currentPageIds = this.tableData.map(item => item.ymsProductId);
        this.selectTableData = this.selectTableData.filter(item => !currentPageIds.includes(item.ymsProductId));
      }
      this.handleSelectTableData();
      this.$forceUpdate();
    },
    // 单个选中列表数据
    tableChange(value, item) {
      if (!value) {
        this.selectTableData.map((ele, index) => {
          if (ele.ymsProductId === item.ymsProductId) {
            this.selectTableData.splice(index, 1);
          }
        })
      }
      this.handleSelectTableData();
    },
    // 处理勾选中的数据
    handleSelectTableData() {
      const currentSelected = this.tableData.filter(item => item.tableChecked);
      this.ymsProductIdList = currentSelected;
      this.selectAllTable = currentSelected.length === this.tableData.length;
    },
    // 跨页记录已勾选的商品
    recordSelectGoods(data) {
      const mergedList = [...this.selectTableData, ...this.ymsProductIdList];
      this.selectTableData = this.uniqueFunc(mergedList, 'ymsProductId');
      if (data && data.length > 0) {
        data.forEach((item, index) => {
          const isSelected = this.selectTableData.some(ele => ele.ymsProductId === item.ymsProductId);
          this.$set(data[index], 'tableChecked', isSelected);
        });
        const currentSelected = this.tableData.filter(item => item.tableChecked);
        this.selectAllTable = currentSelected.length === this.tableData.length;
      }
      this.$forceUpdate();
    },
    // 取消选中的所有数据
    cancelSelectData() {
      this.tableData.map((item) => {
        item.tableChecked = false;
      })
      this.selectTableData = [];
      this.ymsProductIdList = [];
      this.$forceUpdate();
    },
    // 校验库存大小
    verifyInventory() {
      let v = this;
      let talg = true;
      let leftValue = v.pageParams.minCoreAvailableNumber;
      let rightValue = v.pageParams.maxCoreAvailableNumber;
      if (leftValue && rightValue) {
        if (leftValue > rightValue) {
          v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003335'));
          talg = false;
        }
      }
      return talg;
    },
    // 获取选中的时间
    selectTime(data) {
      let v = this;
      let time = data.date;
      let timeList = v.defaultTimePeriod(time);
      let current = data.value;
      v.dropDownTimeList.map((item) => {
        if (item.value === current) {
          let startTimeKey = item.parameterKey[0];
          let endTimeKey = item.parameterKey[1];
          v.$nextTick(() => {
            v.$refs['dropDownDateTime'].timeList = v.defaultTimePeriod(time, false);
          });
          v.pageParams[startTimeKey] = v.$uDate.getUniversalTime(new Date(timeList[0]).getTime(), 'fulltime');
          v.pageParams[endTimeKey] = v.$uDate.getUniversalTime(new Date(timeList[1]).getTime(), 'fulltime');
        }
      });
    },
    // 改变默认时间筛选下拉选项的值
    changeTimeInput(value) {
      this.defaultSelectTimeValue = value;
      this.$refs['dropDownDateTime'].timeList = [];
      this.dropDownTimeList.map((item) => {
        let startTimeKey = item.parameterKey[0];
        let endTimeKey = item.parameterKey[1];
        this.pageParams[startTimeKey] = null;
        this.pageParams[endTimeKey] = null;
      });
    },
    // 重置选中的时间
    resetTime(value) {
      this.dropDownTimeList.map((item) => {
        if (item.value === value) {
          let startTimeKey = item.parameterKey[0];
          let endTimeKey = item.parameterKey[1];
          this.pageParams[startTimeKey] = null;
          this.pageParams[endTimeKey] = null;
        }
      });
    },
    // 批量配置标签
    batchConfigLabelBtn() {
      let v = this;
      if (v.selectTableData.length > 0) {
        v.$refs['batchConfigLabel'].initBatchConfigLabelData(v.selectTableData, v.productTagNamesList);
      } else {
        v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003336'));
        return false;
      }
    },
    // 更新数据
    updateDataFun() {
      this.cancelSelectData();
      this.pageParamsStatus = true;
    },
    // 商品已启用的发货仓
    getDeliveryWarehousesData() {
      return new Promise((resolve) => {
        this.axios.get(api.get_ymsWarehouse_queryDeliveryWarehouseList).then((response) => {
          if (response.data.code === 0) {
            let data = response.data.datas || [];
            let newData = data.filter((item) => {
              return item.status === 1 && item.servicePlatform === 'core';
            });
            this.deliveryWarehousesList = newData;
            resolve(newData);
          }
        });
      })
    },
    // 监听是否滚动距离顶部60px
    scrollFixedTopFun() {
      const TOP_TABDISTANCE = 100;
      const TOP_TABLETITLEDISTANCE = 350;
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop || 0;
      this.fixedTalg = scrollTop > TOP_TABDISTANCE;
      this.fixedTableTitleTalg = scrollTop > TOP_TABLETITLEDISTANCE;
    },
    // 动态设置tab的样式
    tabStyles() {
      let style = {
        width: this.showSidebarMenu ? '100%' : 'calc(100% - 270px)',
        left: this.showSidebarMenu ? '0' : '255px'
      }
      return this.fixedTalg ? style : ''
    },
    // 动态设置table的样式
    tableTitleStyles() {
      let style = {
        width: this.showSidebarMenu ? '100%' : 'calc(100% - 270px)',
        left: this.showSidebarMenu ? '0' : '255px'
      }
      return this.fixedTableTitleTalg ? style : ''
    },
    // 添加商品
    addProductBtn() {
      const {href} = this.$router.resolve({
        path: '/selfOperatedProductsDetails',
        query: {
          type: 'add'
        }
      });
      window.open(href, '_blank');
    },
    // 查看商品详情
    toGoodsDetails(obj) {
      if (obj.isDelete !== 1) {
        const {href} = this.$router.resolve({
          path: '/selfOperatedProductsDetails',
          query: {
            type: 'look',
            productId: obj.ymsProductId,
            supplierMerchantId: obj.supplierMerchantId,
            platformId: obj.platformId || null
          }
        });
        window.open(href, '_blank');
      }
    },
    // 查看SKU详情
    toSkuDetails(obj) {
      const {href} = this.$router.resolve({
        path: '/selfOperatedProductsViewSku',
        query: {
          productId: obj.ymsProductId,
          systemType: 'selfOperatedProducts'
        }
      });
      window.open(href, '_blank');
    },
    // 仓储与价格的展开与收起
    toggleStorageAndPricing(item) {
      item.showAllStorage = !item.showAllStorage;
      item.visibleStorageList = item.showAllStorage ? item.storageAndPricingList : item.storageAndPricingList.slice(0, 2);
      this.$forceUpdate();
    },
    // 操作栏按钮
    getOperationList(item) {
      let {isDelete, ymsProductId, supplierMerchantId, platformId, shelveStatus, imagePath, supplierProductId} = item;
      return [
        {
          text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000985'),
          show: this.getPermission('ymsProductInfoCore_update') && isDelete !== 1,
          clickFn: () => {
            const {href} = this.$router.resolve({
              path: '/selfOperatedProductsDetails',
              query: {
                type: 'edit',
                productId: ymsProductId,
                supplierMerchantId: supplierMerchantId,
                platformId: platformId
              }
            });
            let link = window.location.href;
            localStorage.setItem('originalPath', link);
            setTimeout(() => {
              window.open(href, '_blank');
            }, 500);
          }
        },
        {
          text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000539'),
          show: shelveStatus === 1 && this.getPermission('ymsProductInfoCore_discontinued'),
          clickFn: () => {
            this.shelfBtn(ymsProductId);
          }
        },
        {
          text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000593'),
          show: shelveStatus === 2 && this.getPermission('ymsProductInfoCore_dercarriage'),
          clickFn: () => {
            this.groundingBtn(ymsProductId);
          }
        },
        {
          text: `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000320')}${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000616')}`,
          show: this.getPermission('productGoods_appendYmsCoreExpressBill'),
          clickFn: () => {
            this.$refs['printYunSku'].getProductDetails(ymsProductId);
          }
        },
        {
          text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003337'),
          show: this.getPermission('ymsProductInfoCore_queryForSkuList'),
          clickFn: () => {
            const {href} = this.$router.resolve({
              path: '/selfOperatedProductsViewSku',
              query: {
                productId: ymsProductId,
                systemType: 'selfOperatedProducts'
              }
            });
            window.open(href, '_blank');
          }
        },
        {
          text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003338'),
          show: true,
          clickFn: () => {
            this.$refs['inventoryDetails'].initInventoryDetails('yms_ymsInventory', item);
          }
        },
        {
          text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003340'),
          show: true,
          clickFn: () => {
            to1688ByImg(imagePath);
          }
        },
        {
          text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003341'),
          show: shelveStatus === 1 && this.showProductSaleCountrySet,
          clickFn: () => {
            this.$refs['sellingCountrySetting'].initSellingCountrySettingData('edit', supplierProductId, ymsProductId);
          }
        },
        {
          text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000288'),
          show: this.getPermission('ymsProductInfoCore_queryLog'),
          clickFn: () => {
            this.ymsProductId = ymsProductId;
            this.$refs['commonLog'].initCommonLogData(ymsProductId);
          }
        },
      ]
    }
  },
  destroyed() {
    window.removeEventListener('scroll', this.scrollFixedTopFun);
  },
  deactivated() {
    localStorage.removeItem('seleteYmsProductCategoryId');
  },
  watch: {
    pageParamsStatus(value) {
      let v = this;
      if (value) {
        v.getList();
        v.pageParamsStatus = false;
      }
    },
    // 监听选中的数据
    ymsProductIdList: {
      handler(data) {
        let v = this;
        if (data.length > 0) {
          let list = [...v.selectTableData, ...data];
          v.selectTableData = v.uniqueFunc(list, 'ymsProductId');
        }
      },
      immediate: true,
      deep: true
    }
  },
  components: {
    commonLogModal,
    batchConfigLabelModal,
    dropDownDateTime,
    inventoryDetailsModal,
    classificationSelect,
    dropDownFilter,
    printYunSkuModal,
    exportFieldsModal,
    sellingCountrySettingModal,
    operationButtons,
    importCommodityInfoModal
  }
};
</script>

<style lang="less" scoped>
.container_box {
  .table_box {
    border-radius: 2px;
    border: 1px solid #e8eaec;
    overflow: hidden;

    .table_header_box {
      background-color: #F7F7F7;
      border-right: 2px;
      overflow: hidden;
      height: 46px;
      line-height: 46px;
      padding: 0 20px;
      width: 100%;
      box-sizing: border-box;
      position: relative;

      .title {
        font-weight: 600;
        font-size: 15px;
        color: #000;
      }

      .select_table_box {
        position: absolute;
        top: 0px;
        left: 15px;
        z-index: 10;
      }
    }

    .fixed_table_header_box_style {
      position: fixed;
      background-color: #FFF;
      top: 102px;
      left: 0;
      z-index: 1000;
      width: 100%;
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.08);
    }

    .table_box_item {
      border-radius: 2px;
      border: 1px solid #dcdee2;
      margin-bottom: 15px;
      overflow: hidden;
      background-color: #fff;
      padding: 15px;
      color: #333;

      .commodityInfo_box {
        .img_box {
          width: 70px;
          height: 70px;
          position: relative;
          cursor: pointer;

          img {
            display: inline-block;
            left: 50%;
            max-height: 100%;
            max-width: 100%;
            position: absolute;
            top: 50%;
            transform: translateY(-50%) translateX(-50%);
          }
        }
      }

      .storageAndPricing_box {
        padding-left: 25px;

        .storageAndPricing_item {
          padding: 0 12px 5px 0;
          margin: 0 0 12px 25px;
          align-items: flex-start;
          border-bottom: 1px solid #E8EAEC;

          &:last-child {
            border-bottom: none;
            margin-bottom: 0;
          }
        }
      }
    }

    .no_classify {
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      margin-top: 100px;

      .txt {
        font-size: 15px;
        color: #666;
        margin-top: 15px;
      }
    }
  }

  .fixed_box_style {
    position: fixed;
    background-color: #F5F7F9;
    top: 50px;
    left: 0;
    z-index: 1000;
    width: 100%;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.08);

    /deep/ .ivu-tabs-bar {
      border-bottom: none;
      margin-bottom: 0;
      height: 52px;

      .ivu-tabs-nav .ivu-tabs-tab {
        padding: 16px !important;
      }

      .ivu-tabs-ink-bar {
        height: 3px !important;
      }
    }
  }
}
</style>
